import routeName from '@/router/constant';

export const twidHeader = [
    {
        path: 'twidInit',
        name: routeName.TWID_INIT,
        component: () => import('@/views/identify/init/Index.vue'),
        meta: {
            auth: true,
            metaTitle: '給付帳號約定',
            pageTitle: '給付帳號約定',
            isNeedPolicyCard: true,
            unableBack: true,
        },
    },
    {
        path: 'twidMobile',
        name: routeName.TWID_MOBILE,
        component: () => import('@/views/identify/mobile/index.vue'),
        meta: {
            auth: true,
            title: '輸入行動電話',
            whiteList: [
                routeName.TWID_MOBILE,
            ],
        },
    },
    {
        path: 'twid/result',
        name: routeName.TWID_RESULT,
        component: () => import('@/views/twidResult/index.vue'),
        meta: {
            auth: false,
            title: '驗證中',
            step: {
                title: '驗證中',
            },
        },
    },
];
